import { Spinner, Wrapper } from "./Spinner.css";

const MySpinner = () => {
    return (
        <Wrapper>
            <Spinner />
        </Wrapper>
    );
};
export { Spinner };
export default MySpinner;